var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 0.0900116C13.921 0.0900961 17.9104 4.07936 17.9104 9.00017C17.9103 13.9209 13.921 17.9102 9.00024 17.9103C4.07944 17.9103 0.0901724 13.921 0.0900879 9.00017C0.0900879 4.07931 4.07939 0.0900116 9.00024 0.0900116ZM12.7268 5.27361C12.4579 5.0051 12.0219 5.00494 11.7532 5.27361L8.98657 8.03825L6.24634 5.29802C5.97746 5.02972 5.54142 5.02947 5.27271 5.29802C5.004 5.56672 5.00434 6.00274 5.27271 6.27165L8.01294 9.01189L5.2981 11.7277C5.02937 11.9965 5.02957 12.4325 5.2981 12.7013C5.56696 12.9702 6.00284 12.9702 6.27173 12.7013L8.98657 9.98552L11.7278 12.7267C11.9967 12.9954 12.4326 12.9955 12.7014 12.7267C12.9701 12.4579 12.9701 12.022 12.7014 11.7531L9.96021 9.01189L12.7268 6.24626C12.9951 5.97749 12.9952 5.54237 12.7268 5.27361Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteCircle);
export default __webpack_public_path__ + "static/media/icon-delete-circle.e77c7a44e241945a6ddbc3e60e08459e.svg";
export { ForwardRef as ReactComponent };